import { useEffect, useState } from "react"
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"
import TextField from "@mui/material/TextField"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import DashboardLayout from "monitor/LayoutContainers/DashboardLayout"
import DashboardNavbar from "monitor/Navbars/DashboardNavbar"
import Footer from "monitor/Footer"
import DataTable from "monitor/Tables/DataTable"
import Icon from "@mui/material/Icon"
import { Link, useNavigate } from "react-router-dom"
import config from "config"
import MDButton from "components/MDButton"
import Chip from "@mui/material/Chip"
import Swal from "sweetalert2"
import { showToast } from "utils/swalToast"

function Roles() {
  const [data, setData] = useState([])
  const navigate = useNavigate()

  const columns = [
    { Header: "Item", accessor: "item", width: "5%" },
    { Header: "Nombre", accessor: "nombre", width: "25%" },
    { Header: "Descripción", accessor: "descripcion", width: "50%" },
    { Header: "Superadmin", accessor: "datosGlobales", width: "10%" },
    { Header: "Activo", accessor: "activo", width: "10%" },
    { Header: "Acciones", accessor: "action", align: "center", width: "10%" },
  ]

  const [nombreFilter, setNombreFilter] = useState("")

  const handleNombreFilterSearch = (event) => {
    const term = event.target.value
    setNombreFilter(term)
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault()
      fetchRoles(nombreFilter, setData)
    }
  }

  const fetchRoles = async (nombreFilter, setData) => {
    try {
      const queryParams = new URLSearchParams()

      if (nombreFilter) queryParams.append("nombreFilter", nombreFilter)

      const queryString = queryParams.toString()

      let url = queryString
        ? `${config.api.baseURL}/roles?${queryString}`
        : `${config.api.baseURL}/roles`

      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      if (response.status === 200) {
        const result = await response.json()
        addColumns(result)
        setData(result)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  function addColumns(dataColumns) {
    let c = 0
    dataColumns.map((d) => {
      d.action = (
        <MDBox>
          {d.nombre !== "superadmin" && d.nombre !== "admin" && (
            <>
              <MDButton
                sx={{ mr: 1 }}
                variant="gradient"
                color="success"
                iconOnly
                onClick={() => handleEdit(d.idRoles)}
              >
                <Icon>edit</Icon>
              </MDButton>
              <MDButton
                variant="gradient"
                color="error"
                iconOnly
                onClick={() => handleDelete(d.idRoles)}
              >
                <Icon>delete</Icon>
              </MDButton>
            </>
          )}
        </MDBox>
      )
      d.activo
        ? (d.activo = <Chip label="Si" color="success" variant="outlined" />)
        : (d.activo = <Chip label="No" color="error" variant="outlined" />)
      d.datosGlobales
        ? (d.datosGlobales = <Chip label="Si" color="success" variant="outlined" />)
        : (d.datosGlobales = <Chip label="No" color="error" variant="outlined" />)
      d.item = ++c
    })
    return dataColumns
  }

  function handleDelete(id) {
    Swal.fire({
      title: "¿Está seguro que desea eliminar este rol?",
      text: "¡No podrás revertir esta acción!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        // El usuario confirmó la eliminación, realizar la solicitud DELETE
        let url = `${config.api.baseURL}/roles/${id}`
        const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

        fetch(url, {
          method: "DELETE",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              showToast({ title: "Rol eliminado exitosamente", icon: "success" })
              fetchRoles(nombreFilter, setData)
            } else {
              showToast({
                icon: "error",
                title: "Error",
                text: response.body.error || "No se pudo eliminar el rol.",
              })
            }
          })
          .catch((error) => {
            const err = error.message
            showToast({ icon: "error", title: "Error", text: err })
          })
      }
    })
  }

  function handleEdit(id) {
    navigate(`/roles/${id}`)
  }

  var handleBuscar = async () => {
    console.log("buscar")
    await fetchRoles(nombreFilter, setData)
  }

  useEffect(() => {
    fetchRoles(nombreFilter, setData)
  }, [])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={5} justifyContent="space-between">
          <Grid item xs={12}>
            <Card>
              <MDBox pt={3} px={2}>
                <Card sx={{ p: 2, mb: 3 }}>
                  <MDTypography variant="h6" color="text" gutterBottom>
                    Filtros
                  </MDTypography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                      <TextField
                        label="Nombre"
                        variant="outlined"
                        fullWidth
                        value={nombreFilter}
                        onChange={handleNombreFilterSearch}
                        onKeyDown={handleKeyDown}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <MDButton
                        type="submit"
                        variant="gradient"
                        color="info"
                        onClick={handleBuscar}
                      >
                        Buscar
                      </MDButton>
                      &nbsp;
                      <MDButton
                        type="button"
                        variant="outlined"
                        color="info"
                        onClick={async () => {
                          setNombreFilter("")
                          await fetchRoles("", setData)
                        }}
                      >
                        Limpiar
                      </MDButton>
                    </Grid>
                  </Grid>
                </Card>
                <Grid item xs={12} sm={6} md={12}>
                  <Link to="/roles/agregar">
                    <MDButton type="button" variant="gradient" color="success">
                      Agregar
                    </MDButton>
                  </Link>
                </Grid>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  isSorted={false}
                  noEndBorder
                  showTotalEntries={false}
                  entriesPerPage={false}
                  canSearch={false}
                  table={{
                    columns: columns,
                    rows: data,
                  }}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default Roles
